import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@metarouter-private/mr-mui';

export default function HttpStatusCell({ responseStatus }) {
  if (responseStatus === null) {
    return <Typography variant="body2">—</Typography>;
  }

  return <Typography variant="body2">{responseStatus}</Typography>;
}

HttpStatusCell.propTypes = {
  responseStatus: PropTypes.number,
};
